<template>
  <GenericBanner :displayed="displayed" class="search-banner py-4">
    <div class="absolute top-0 right-2 md:right-4 lg:right-10">
      <IconCross
        @click="$emit('closeButtonClick')"
        class="h-8 w-6 cursor-pointer font-black text-black"
      />
    </div>

    <div class="w-full">
      <div class="py-2 align-middle md:hidden px-12">
        <p class="pb-2 text-center text-lg font-normal">
          Want a customised list of agencies?
          <span
            @click="$emit('displaySearchBar')"
            class="inline-block cursor-pointer font-black underline"
            >Do&nbsp;a&nbsp;Search</span
          >
        </p>
      </div>

      <div class="mt-5 mb-2.5 hidden md:block">
        <p class="text-2xl font-normal">
          Would you like a list of agencies that exactly matches your
          requirements?
        </p>
        <p class="py-2 text-sm">
          Search our 9,000+ listed agencies. Enter your required
          <span
            @click="$emit('displaySearchBar')"
            class="cursor-pointer font-bold underline"
          >
            Industry, Location and Type of Employment
          </span>
        </p>
      </div>
    </div>
  </GenericBanner>
</template>

<script>
import GenericBanner from 'Components/Banners/GenericBanner';
import IconCross from 'Components/Icons/IconCross';

export default {
  name: 'StaticSearchBanner',
  components: {
    GenericBanner,
    IconCross,
  },
  props: {
    displayed: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
